import { UserTable } from "@/components/features/settings/users/UserTable";

export default function UsersCard({
  isInvitingUser,
  setIsInvitingUser,
  isReassigningUser,
  setIsReassigningUser,
}: {
  isInvitingUser: boolean;
  setIsInvitingUser: (open: boolean) => void;
  isReassigningUser: boolean;
  setIsReassigningUser: (open: boolean) => void;
}) {
  return (
    <UserTable
      isInvitingUser={isInvitingUser}
      setIsInvitingUser={setIsInvitingUser}
      isReassigningUser={isReassigningUser}
      setIsReassigningUser={setIsReassigningUser}
    />
  );
}
